import { render, staticRenderFns } from "./MovablePopup.vue?vue&type=template&id=280c7df3&scoped=true&"
import script from "./MovablePopup.vue?vue&type=script&lang=js&"
export * from "./MovablePopup.vue?vue&type=script&lang=js&"
import style0 from "./MovablePopup.vue?vue&type=style&index=0&id=280c7df3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c7df3",
  null
  
)

export default component.exports